import React from 'react'

import { capitalize, getOnlineType } from '@root/utility'

import Image     from '@Pure/Image'
import Link      from '@Pure/Link'
import Logo      from '@Pure/Logo'

export default function ProductCard ({ product, ...props })
{
	let themes, places;

	if (product._place_themes?.length)
	{
		themes = product._place_themes
		.filter(theme => !theme ? false : true)
		.map(function (theme, key)
		{
			return (
				<div className="c-model-preview__theme" key={ key }>
					{ theme.label }
				</div>
			);
		});

		themes =
		(
			<div className="c-model-preview__themes">
				{ themes }
			</div>
		);
	}

	const displayed_places = (product._places || [])
	.map(function (place, i)
	{
		let string = '';

		if (i > 0)
		{
			string += ', ';
		}

		if (product._places.length <= 2)
		{
			string += place.name;
		}
		else
		{
			place.address = place.address || { };

			if (place.address.city)
			{
				string += capitalize(place.address.city);
			}

			if (place.address.zip_code)
			{
				string += ' (' + place.address.zip_code.slice(0, 2) + ')';
			}
		}

		return string;
	});

	if (product._places)
	{
		places =
		(
			<div className="c-model-preview__places">
				<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
					<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
				</svg>
				{ displayed_places }
			</div>
		);
	}

	const thumbnail = product._thumbnail?.url ?
	(
		<Image className="c-model-preview__img" src={ product._thumbnail?.url } />
	)
	:
	(
		<Logo className="c-model-preview__img default" type="svg"
			synergies={ true }
		/>
	);

	const online_type = getOnlineType(product.online_type);

	return (
		<div className="c-model-preview-item product o-grid__item u-flex">

			<div className="c-model-preview c-model-preview--product">

				{
					online_type ?
					(
						<Link className="c-model-preview__online-type"
							href={ '/accueil/catalogue/' + product.id }>
							{ online_type }
						</Link>
					)
					: undefined
				}

				<div className="c-model-preview__thumb">
					<Link className="c-model-preview__thumb-link"
						href={ '/accueil/catalogue/' + product.id }>
						{ thumbnail }
					</Link>
				</div>

				<h2 className="c-model-preview__title">
					<Link href={ '/accueil/catalogue/' + product.id }
						className="c-model-preview__title-link">
						{ product.name }
					</Link>
				</h2>

				{ themes }

				<div className="c-model-preview__infos">

					<div className="c-model-preview__description">
						{ product._short_description }
					</div>

					{ places }

					<div className="c-model-preview__buttons">
						<Link href={ '/accueil/catalogue/' + product.id }
							className="c-model-preview__link">
							<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
								<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
							</svg>Fiche produit
						</Link>
					</div>

				</div>
			</div>

		</div>
	);
}